// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2lHUA","footer":"ChangeClinic_footer__3-moa"};